import React, { useEffect, useState } from "react";
import { dateFormator, mapTableRows } from "../../../../utils";
import { formatCurrency } from "../../../../utils/stringUtils";
import {
  Avatar,
  Button,
  CopyToClipboard,
  DropdownMenu,
  FormFieldSet,
  InvoiceModals,
  NewTable,
  SmartTooltip,
  TableAdv,
} from "../../../../components";
import ReceivePayment from "./ReceivePayment";
import InvoiceDetails from "./InvoiceDetails";
import InvoiceFilters from "./InvoiceFilters";
import qb from "../../../../assets/qb.svg";
import { usePagination } from "../../../../hooks";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import {
  getCurrentInvoiceStart,
  getOpenInvoicesStart,
  getPaidInvoicesStart,
} from "../../../../redux/slices/invoices/invoicesSlice";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import InvoiceViewModal from "./Modals/InvoiceViewModal";
import EditInvoice from "./EditInvoice";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { handleDownloadPdf, handleResendInvoice } from "./AllInvoices";
import ResendModal from "../Modals/ResendModal";

const PaidInvoices = () => {
  const dispatch = useDispatch();
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      // dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    },
  );
  const { value } = useSelector((state) => state.totalCount);
  const { paidInvoices, currentInvoices } = useSelector(
    (state) => state.invoices,
  );
  const PaidInvoicesTableData = paidInvoices?.data?.[0]?.data || [];
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const totalCount = paidInvoices?.data?.[0]?.total?.[0]?.count || 0;
  const [activeModal, setActiveModal] = useState(null);
  const [viewModal, setViewModal] = useState(false);
  const [receivePayment, setReceivePayment] = useState(false);
  const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);
  const [showEditInvoice, setShowEditInvoice] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [sortConfig, setSortConfig] = useState({
    field: "uiid",
    direction: -1,
  });
  const { userData: loginUserData } = useLoginUser();
  const [downloadId, setDownloadId] = useState(null);
  const [resendId, setResendId] = useState(null);
  const [isResendModalOpen, setIsResendModalOpen] = useState(false);
  const [isMailSaving, setIsMailSaving] = useState(false);
  const [selEmployees, setSelEmployees] = useState("");
  const [selClients, setSelClients] = useState("");
  const [dateRange, setDateRange] = useState({ from: null, to: null });
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    if (downloadId && currentInvoices?.uiid === downloadId) {
      handleDownloadPdf(currentInvoices, loginUserData);
      setDownloadId(null);
    }
  }, [currentInvoices, downloadId, loginUserData]);

  useEffect(() => {
    if (resendId && currentInvoices?.uiid === resendId) {
      setIsResendModalOpen(true);
      setResendId(null);
    }
  }, [currentInvoices, resendId]);

  // Reset page to 1 whenever any filter changes
  useEffect(() => {
    setPage(1);
  }, [selEmployees, selClients, dateRange, setPage]);
  const handleCloseModal = () => setActiveModal(null);
  const handleClickInvoiceNumber = (row) => {
    setSelectedInvoice(row);
    setShowInvoiceDetails(true);

    dispatch(
      getCurrentInvoiceStart({
        filters: { uiid: { type: "NONE", value: row.uiid } },
        coll: "Invoice",
        ref: "Client Employee Placement Timesheet",
        // incl: ["businessName uiid", "firstName lastName"],
        incl: ["", "firstName lastName", "", "attachments"],
      }),
    );
  };
  const tableData = [
    {
      id: 1,
      invoiceNumber: "1135",
      employeeName: "Srujana Gudla (EMP-1018)",
      client: "Tekintegral Inc",
      invoiceDate: "2025-04-04T00:00:00.000Z",
      invoiceDueDate: "2025-05-04T00:00:00.000Z",
      invoicedAmount: "12768.00 USD",
      receivedAmount: "0.00 USD",
      statementMemo: "Srujana Gudla (03/01/2025 TO 03/31/2025)",
      dueAmount: "0.00 USD",
      lastPaymentDate: "2025-10-05T00:00:00.000Z",
    },
    {
      id: 2,
      invoiceNumber: "1136",
      employeeName: "Srujana Gudla (EMP-1018)",
      client: "Tekintegral Inc",
      invoiceDate: "2025-04-04T00:00:00.000Z",
      invoiceDueDate: "2025-05-04T00:00:00.000Z",
      invoicedAmount: "12768.00 USD",
      receivedAmount: "0.00 USD",
      statementMemo: "Srujana Gudla (03/01/2025 TO 03/31/2025)",
      dueAmount: "0.00 USD",
      lastPaymentDate: "2025-10-05T00:00:00.000Z",
    },
    {
      id: 3,
      invoiceNumber: "1137",
      employeeName: "Srujana Gudla (EMP-1018)",
      client: "Tekintegral Inc",
      invoiceDate: "2025-04-04T00:00:00.000Z",
      invoiceDueDate: "2025-05-04T00:00:00.000Z",
      invoicedAmount: "12768.00 USD",
      receivedAmount: "0.00 USD",
      statementMemo: "Srujana Gudla (03/01/2025 TO 03/31/2025)",
      dueAmount: "0.00 USD",
      lastPaymentDate: "2025-10-05T00:00:00.000Z",
    },
  ];
  const columns = [
    {
      key: "invoiceNum",
      label: "Invoice Number",
      // render: (row) => (
      //   <div className="flex items-center gap-1 cursor-pointer">
      //     <span
      //       className="text-linkblue cursor-pointer"
      //       onClick={() => {
      //         setSelectedInvoice(row);
      //         setShowInvoiceDetails(true);
      //       }}
      //     >
      //       {row.invoiceNumber}
      //     </span>
      //   </div>
      // ),
      render: (row) => (
        <div className="flex items-center gap-3">
          <div
            className={`flex gap-2 items-center cursor-pointer text-info `}
            onClick={() => {
              handleClickInvoiceNumber(row);
            }}
          >
            <span className="material-symbols-rounded text-[14px] mr-[2px] ">
              mark_as_unread
            </span>
            {row.invoiceNum}
          </div>
          {/* <div className="flex  items-center">
            <Button
              type={"icon"}
              variant="text"
              color="black"
              icon={"description"}
              className="!justify-start py-1"
              size="xs-sm"
            />
            <DropdownMenu
              MenuSection={
                <div className="flex flex-col">
                  <Button
                    title={"Edit"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    icon={"edit_square"}
                    size="xs-sm"
                  />
                  <Button
                    icon={"download"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    title={"Download PDF"}
                    size="xs-sm"
                  />
                  <Button
                    icon={"send"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    title={"Send Reminder to Invoice Recipients"}
                    size="xs-sm"
                  />
                  <Button
                    icon={"outgoing_mail"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    title={"Resend Invoice"}
                    size="xs-sm"
                  />
                  <Button
                    icon={"mark_as_unread"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    title={"Submit Invoice"}
                    size="xs-sm"
                  />
                  <Button
                    icon={"delete"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    title={"Delete"}
                    size="xs-sm"
                  />
                </div>
              }
            >
              <Button
                icon="more_vert"
                type="icon"
                variant="text"
                color="black"
                size="sm"
              />
            </DropdownMenu>
          </div> */}
          <div className="flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            <SmartTooltip
              noicon
              description="View Invoice PDF"
              tooltipPosition="top"
              portal={true}
            >
              <Button
                type={"icon"}
                variant="text"
                color="black"
                icon={"description"}
                className="!justify-start py-1"
                size="xs-sm"
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(
                    getCurrentInvoiceStart({
                      filters: { uiid: { type: "NONE", value: row.uiid } },
                      coll: "Invoice",
                      ref: "Client Employee Placement Timesheet",
                      incl: ["", "firstName lastName", "", "attachments"],
                    }),
                  );
                  setViewModal(true);
                }}
              />
            </SmartTooltip>
            {/* <Button
              type={"icon"}
              variant="text"
              color="black"
              icon={"description"}
              className="!justify-start py-1"
              size="xs-sm"
            /> */}
            <DropdownMenu
              MenuSection={
                <div className="flex flex-col">
                  <Button
                    title={"Edit"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    icon={"edit_square"}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedInvoice(row);
                      setShowEditInvoice(true);
                      dispatch(
                        getCurrentInvoiceStart({
                          filters: { uiid: { type: "NONE", value: row.uiid } },
                          coll: "Invoice",
                          ref: "Client Employee Placement Timesheet",
                          incl: ["", "firstName lastName", "", "attachments"],
                        }),
                      );
                    }}
                    size="xs-sm"
                  />
                  <Button
                    icon={"download"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    title={"Download PDF"}
                    size="xs-sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDownloadId(row.uiid);
                      dispatch(
                        getCurrentInvoiceStart({
                          filters: { uiid: { type: "NONE", value: row.uiid } },
                          coll: "Invoice",
                          ref: "Client Employee Placement Timesheet",
                          incl: ["", "firstName lastName", "", "attachments"],
                        }),
                      );
                    }}
                  />
                  <Button
                    icon={"send"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    title={"Send Reminder to Invoice Recipients"}
                    size="xs-sm"
                  />
                  <Button
                    icon={"outgoing_mail"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    title={"Resend Invoice"}
                    size="xs-sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      setResendId(row.uiid);
                      dispatch(
                        getCurrentInvoiceStart({
                          filters: { uiid: { type: "NONE", value: row.uiid } },
                          coll: "Invoice",
                          ref: "Client Employee Placement Timesheet",
                          incl: [
                            "businessName roleContacts",
                            "firstName lastName",
                            "",
                            "attachments",
                          ],
                        }),
                      );
                    }}
                  />
                  <Button
                    icon={"mark_as_unread"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    title={"Submit Invoice"}
                    disabled={true}
                    size="xs-sm"
                  />
                  <Button
                    icon={"delete"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    title={"Delete"}
                    size="xs-sm"
                  />
                </div>
              }
            >
              <Button
                icon="more_vert"
                type="icon"
                variant="text"
                color="black"
                size="sm"
              />
            </DropdownMenu>
          </div>
        </div>
      ),
    },
    {
      key: "employeeName",
      label: "Employee Name",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.employeeName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">{row?.employeeName}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "memo",
      label: "Statement Memo",
      width: "min-w-[350px]! max-w-[350px]!",
      render: (row) => (
        <SmartTooltip
          description={row.memo}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="flex items-center gap-3 group">
            <div
              className={`flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 ${
                row?.memo === "-" ? "invisible" : "visible"
              }`}
            >
              <CopyToClipboard
                tooltipPosition={"left"}
                title={"Statement Memo"}
                content={row?.memo}
              />
            </div>
            <div className="line-clamp-1!">{row?.memo}</div>
          </div>
        </SmartTooltip>
      ),
    },
    {
      key: "clientName",
      label: "Client",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.clientName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">{row?.clientName}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "invoiceDate",
      label: "Invoice Date",
      sortfun: (direction) => handleSort("invoiceDate", direction),
      // render: (row) => dateFormator(row.invoiceDate, "month-day-year"),
      render: (row) => (
        <SmartTooltip
          description={dateFormator(row.invoiceDate, "month-day-year")}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">
            {dateFormator(row.invoiceDate, "month-day-year")}
          </div>
        </SmartTooltip>
      ),
    },
    {
      key: "dueDate",
      label: "Invoice Due Date",
      sortfun: (direction) => handleSort("dueDate", direction),
      // render: (row) => dateFormator(row.dueDate, "month-day-year"),
      render: (row) => (
        <SmartTooltip
          description={dateFormator(row.dueDate, "month-day-year")}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">
            {dateFormator(row.dueDate, "month-day-year")}
          </div>
        </SmartTooltip>
      ),
    },

    {
      key: "invoicedAmount",
      label: "Invoiced Amount",
      render: (row) => (
        <SmartTooltip
          description={row?.amounts?.invoiced}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">{row?.amounts?.invoiced}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "receivedAmount",
      label: "Received Amount",
      render: (row) => (
        <SmartTooltip
          description={row?.amounts?.received}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">{row?.amounts?.received}</div>
        </SmartTooltip>
      ),
    },

    {
      key: "lastPaymentDate",
      label: "Last Payment Date",
      sortfun: (direction) => handleSort("lastPaymentDate", direction),
      render: (row) => dateFormator(row.lastPaymentDate, "month-day-year"),
    },
  ];
  const mappedRows = mapTableRows(PaidInvoicesTableData, columns);

  const handleSort = (field, direction) => {
    setSortConfig({
      field,
      direction: direction === "asc" ? 1 : -1,
    });
  };
  const changeInvoiceModal = () => {
    console.log("clik");
  };

  const handleBackNavigation = () => {
    setReceivePayment(false);
    setShowInvoiceDetails(false);
    setSelectedInvoice(null);
  };
  useEffect(() => {
    // dispatch(
    //   totalCountStart({
    //     collection: "invoices",
    //     coll: "Invoice",
    //     tname: "PaidInvoice",
    //     //filters: item.filters,
    //     filters: {
    //       // dueDate: { type: "GT", value: dayjs().startOf("day") },
    //       "amounts.invoiced": { type: "FIELD_EQ", value: "amounts.received" },
    //       "version.isLatest": {
    //         type: "NONE",
    //         value: true,
    //       },
    //     },
    //   }),
    // );
    dispatch(
      getPaidInvoicesStart({
        limit,
        page,
        coll: "Invoice",
        ret: "dueDate uiid invoiceNum invoiceDate dueDate amounts memo netTerms",
        // filters: {
        //   search: { type: "SEARCH", value: searchValue },
        //   "amounts.invoiced": { type: "FIELD_EQ", value: "amounts.received" },
        //   "version.isLatest": {
        //     type: "NONE",
        //     value: true,
        //   },
        // },
        useAggregate: true,
        sort: { [sortConfig.field]: sortConfig.direction },
        filters: {
          // search: { type: "SEARCH", value: searchValue },
          placementTS: {
            type: "AG_INVOICE_SEARCH",
            value: [searchValue, "paid"],
          },
          ...(selEmployees && {
            employeeId: { type: "IN", value: [selEmployees.value] },
          }),
          ...(selClients && {
            clientId: { type: "IN", value: [selClients.value] },
          }),
          ...((dateRange?.from || dateRange?.to) && {
            invoiceDate:
              dateRange.from && dateRange.to
                ? { type: "BETWEEN", value: [dateRange.from, dateRange.to] }
                : dateRange.from
                  ? { type: "GTE", value: dateRange.from }
                  : { type: "LTE", value: dateRange.to },
          }),
        },
        ref: "Client Employee",
        incl: ["businessName uiid", "firstName lastName"],
      }),
    );
  }, [
    dispatch,
    page,
    limit,
    searchValue,
    sortConfig,
    selEmployees,
    selClients,
    dateRange,
  ]);

  const handleSearch = (keyname, value) => {
    setSearchValue(value);
  };
  return (
    <div className="flex flex-col overflow-hidden">
      {showInvoiceDetails ? (
        <InvoiceDetails
          onBack={() => {
            setShowInvoiceDetails(false);
            setSelectedInvoice(null);
          }}
          invoiceData={selectedInvoice}
          setEditInvoice={() => {
            // Edit logic can go here
          }}
        />
      ) : showEditInvoice ? (
        <EditInvoice
          onBack={() => {
            setShowEditInvoice(false);
            setSelectedInvoice(null);
          }}
          currentInvoices={currentInvoices}
        />
      ) : (
        <TableAdv
          tableId={"invoices_paidinvoicestable"}
          defaultSelectedRows={selectedRowIds}
          onSelectionChange={(ids) => setSelectedRowIds(ids)}
          showCheckbox
          rows={mappedRows}
          columns={columns}
          // toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
          serverPagination={true}
          totalCount={totalCount}
          // customSection={
          toolbarLeft={{
            add: [
              {
                component: (
                  <SmartTooltip
                    description="Filters"
                    noicon
                    tooltipPosition="bottom"
                  >
                    <Button
                      type="icon"
                      icon={showFilters ? "filter_alt_off" : "filter_alt"}
                      variant="text"
                      color={showFilters ? "danger" : "black"}
                      onClick={() => setShowFilters(!showFilters)}
                    />
                  </SmartTooltip>
                ),
              },
              ...(showFilters
                ? [
                    {
                      component: (
                        <InvoiceFilters
                          selEmployees={selEmployees}
                          setSelEmployees={setSelEmployees}
                          selClients={selClients}
                          setSelClients={setSelClients}
                          dateRange={dateRange}
                          setDateRange={setDateRange}
                        />
                      ),
                    },
                  ]
                : []),
            ],
          }}
          toolbarRight={{
            search: !showFilters,
            add: [
              {
                component: (
                  <div className="flex">
                    {/* <Button
                          type="icon"
                          icon={"swap_horiz"}
                          variant="text"
                          onClick={() => setActiveModal("changeInvoice")}
                        />
                        <Button
                          type="icon"
                          icon={"alarm"}
                          variant="text"
                          onClick={() => setActiveModal("reminder")}
                        />
                        <Button
                          type="icon"
                          icon={"sticky_note"}
                          variant="text"
                          onClick={() => setActiveModal("note")}
                        />
                        <Button
                          type="icon"
                          icon={"stacked_email"}
                          variant="text"
                          onClick={() => setActiveModal("email")}
                        /> */}
                    {/* <Button
                    type="icon"
                    icon={"add"}
                    variant="text"
                    color="black"
                    onClick={() => setActiveModal("addQb")}
                  /> */}
                    <button
                      onClick={() => setActiveModal("addQb")}
                      className="mx-1"
                    >
                      <Avatar src={qb} alt={"qb"} size="xs" outline />
                    </button>
                    <Button
                      type="icon"
                      icon={"delete"}
                      variant="text"
                      onClick={() => setActiveModal("delete")}
                    />
                  </div>
                ),
              },
            ],
          }}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          serverSerchValue={searchValue}
          serverOnSearch={handleSearch}
        />
      )}
      <InvoiceModals
        activeModal={activeModal}
        handleCloseModal={handleCloseModal}
      />
      <InvoiceViewModal
        isOpen={viewModal}
        onClose={() => setViewModal(false)}
        invoiceData={currentInvoices}
      />
      {isResendModalOpen && (
        <ResendModal
          open={isResendModalOpen}
          onClose={() => setIsResendModalOpen(false)}
          toEmail={
            currentInvoices?.clientId?.roleContacts
              ?.filter((data) => data.role === "Accounts")
              ?.flatMap((item) => item.email) || []
          }
          ccEmail={currentInvoices?.jobId?.invoices?.cc || []}
          templateName="invoice_created"
          data={{
            orgLogo: loginUserData?.organizationId?.logo?.company || "",
            orgName: loginUserData?.organizationId?.name || "",
            invoiceNum: currentInvoices?.invoiceNum || "",
            client: currentInvoices?.clientId?.businessName || "",
            // dueDate: dateFormator(currentInvoices?.dueDate) || "",
            // invoiceDate: dateFormator(currentInvoices?.dueDate),
            dueDate: dayjs(currentInvoices?.dueDate).format("MM/DD/YYYY") || "",
            invoiceDate:
              dayjs(currentInvoices?.invoiceDate).format("MM/DD/YYYY") || "",
            amount: formatCurrency(currentInvoices?.amounts?.invoiced) || "",
            invoiceUrl: `${window.location.origin}/view/${loginUserData?.organizationId?.uiid}/${currentInvoices?._id}`,
          }}
          isMailSaving={isMailSaving}
          handleSave={(mailDetails) =>
            handleResendInvoice(
              mailDetails,
              currentInvoices,
              setIsMailSaving,
              setIsResendModalOpen,
            )
          }
        />
      )}
    </div>
  );
};

export default PaidInvoices;
